import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to the top of the page on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // Smooth scrolling for better UX
    });
  }, [pathname]); // Trigger whenever the pathname changes

  return null; // This component does not render anything
};

export default ScrollToTop;